import { dispatchBroadcastChannel } from 'hooks/useBroadcastChannel';
import { ContactInformationFormType } from 'types/form';
import { SelectOptionType } from 'types/selectOptions';
import { StateCreator } from 'zustand';

const initialState: ContactInformationFormType = {
    email: '',
    register: false,
    passwordFirst: '',
    passwordSecond: '',
    companyCustomer: undefined,
    telephone: '',
    birthDay: null,
    firstName: '',
    lastName: '',
    street: '',
    houseNumber: '',
    district: { value: '', label: '' },
    city: '',
    postcode: '',
    country: { value: '', label: '' },
    companyName: '',
    companyName2: '',
    companyEmail: '',
    companyTelephone: '',
    companyNumber: '',
    companyTaxNumber: '',
    companyTaxIdNumber: '',
    differentDeliveryAddress: false,
    deliveryFirstName: '',
    deliveryLastName: '',
    deliveryCompanyName: '',
    deliveryCompanyName2: '',
    deliveryTelephone: '',
    deliveryEmail: '',
    deliveryStreet: '',
    deliveryHouseNumber: '',
    deliveryDistrict: { value: '', label: '' },
    deliveryCity: '',
    deliveryPostcode: '',
    deliveryCountry: { value: '', label: '' },
    deliverySapId: '',
    createInvoice: false,
    gdprConsents: [],
    note: '',
    isLoginPopupOpen: false,
    sendQuestionnaire: false,
    sapId: '',
    b2bInternalOrderNumber: '',
    b2bRequestedDeliveryDate: null,
};

export type ContactInformationSlice = ContactInformationFormType & {
    updateContactInformationState: (value: Partial<ContactInformationSlice>) => void;
    updateDeliveryAddressState: (
        value: Partial<{
            street: string;
            city: string;
            postcode: string;
            country: SelectOptionType;
            firstName?: string;
            lastName?: string;
        }>,
        dispatchBroadcastActive?: boolean,
    ) => void;
    resetContactInformationState: (dispatchBroadcastActive?: boolean) => void;
};

export const createContactInformationSlice: StateCreator<ContactInformationSlice> = (set) => ({
    ...initialState,

    updateContactInformationState: (value) => {
        set(value);
    },

    resetContactInformationState: (dispatchBroadcastActive = true) => {
        set(initialState);
        if (dispatchBroadcastActive) {
            dispatchBroadcastChannel({
                name: 'currentCustomerUserBroadcast',
                data: { currentCustomerUser: 'userInformation' },
            });
        }
    },

    updateDeliveryAddressState: (value, dispatchBroadcastActive = true) => {
        set({
            deliveryFirstName: value.firstName ?? '',
            deliveryLastName: value.lastName ?? '',
            ...value,
        });
        if (dispatchBroadcastActive) {
            dispatchBroadcastChannel({
                name: 'currentCustomerUserBroadcast',
                data: { currentCustomerUser: 'contactInformation' },
            });
        }
    },
});
